
import { shortnames} from '../constants/benefits';

// helpers/benefitsHelpers.js
export const getArrPeriods = () => {
  const curDate = new Date();
  const startPeriod = new Date('2021-12-01');
  const [curY, curM] = [curDate.getFullYear(), curDate.getMonth()];

  const periods = [`${curM + 1}.${curY}`];

  for (;;) {
    const [cM, cY] = periods[periods.length - 1].split('.');
    const newM = (+cM - 1) > 0 ? (+cM - 1) : 12;
    const newY = (+cM - 1) > 0 ? (+cY) : (+cY - 1);

    if (new Date(newY, newM - 1, 2) < startPeriod) break;
    periods.push(`${newM}.${newY}`);
  }

  return periods;
};

export const fieldForSchema = (data) => {
  const row = {h: `${shortnames[data.benefitId].short}`, f: data.benefitId, t: data.name, b: true};
  return row;
};

export const fieldForSchemaKitchen = (data) => {
  const row = {h: `${data.name.shname}`, f: data.benefitid, t: data.name.name, b: true};
  return row;
};

export const convData = (data) => {
  if (!data || !Array.isArray(data)) return { schema_f: [], data_c: [] };

  const result = [];
  const schfields = [];
  const fields = {};

  data.forEach((el, i) => {
    const { benefits } = el;
    benefits.forEach(b => {
      const { benefitId } = b;
      const cur_f = fieldForSchema(b);
      if (!fields[benefitId]) {
        fields[benefitId] = cur_f;
        schfields.push(fieldForSchema(b));
      }
      el[cur_f['f']] = b.count;
    });

    result.push(el);
  });

  return {
    schema_f: schfields.sort((a, b) => a.h.localeCompare(b.h)), 
    data_c: result.sort((a, b) => a.district.localeCompare(b.district) || a.kgnumber.localeCompare(b.kgnumber))
      .map((el, i) => Object.assign({}, el, { number: i + 1 }))
  };
};

export const convDataKitchen = (data) => {
  if (!data || !Array.isArray(data)) return { schema_f: [], data_c: [] };

  const result = [];
  const schfields = [];
  const fields = {};

  data.forEach((el, i) => {
    const { benefits } = el;

    benefits.forEach((b, idx) => {
      const { benefitid, count } = b;
      const cur_f = fieldForSchemaKitchen(b);
      if (!fields[benefitid]) {
        fields[benefitid] = cur_f;
        schfields.push(fieldForSchemaKitchen(b));
      }
      el[cur_f['f']] = +count;
      b.count = +count;
    });

    result.push(el);
  });

  return {
    schema_f: schfields.sort((a, b) => a.h.localeCompare(b.h)), 
    data_c: result.sort((a, b) => a.district.localeCompare(b.district) || a.kgnumber.localeCompare(b.kgnumber))
      .map((el, i) => Object.assign({}, el, { number: i + 1 }))
  };
};

export const getBenefitsLists = (shortnames, shortnames_kitch) => ({
  benefits_kg: Object.keys(shortnames).map(k => ({name: shortnames[k]["short"], id: k })),
  benefits_kitch: Object.keys(shortnames_kitch).map(k => ({name: shortnames_kitch[k]["short"], id: k }))
});